module.exports = __webpack_public_path__ + "img/wlzg-logo-icon.632529dd.png";